<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
    />
    <Editor
        style="height: 500px; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
    />
    <el-progress
        v-show="showProgress"
        style="margin: 3px;width: 99%"
        :text-inside="true"
        :stroke-width="13"
        :percentage="progress"
    ></el-progress>
    <el-dialog title="客服文档列表" :visible.sync="showDialog" v-if="showDialog" :append-to-body='true'  width="60%">
      <el-table :data="csFileList" highlight-selection-row height="450">
        <el-table-column property="fileShowName" align="center" label="文件名" ></el-table-column>
        <el-table-column property="fileSuffix" align="center" label="格式" width="100"></el-table-column>
        <el-table-column property="fileSize" align="center" label="大小（MB）" width="100">
          <template slot-scope="scope">
            {{ (scope.row.fileSize / 1024).toFixed(1) }}
          </template>
        </el-table-column>
        <el-table-column property="nickname" align="center" label="上传者" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="上传时间" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <el-button type="text" >预览</el-button>
            <el-button type="text" @click.stop="quoteFile(scope.row)" >引用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="total > pageSize"  style="margin-top:5px" class="pagination">
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="total"
            :current-page="pageNumber"
            @current-change="currentChange"
        />
      </div>
      <div style="margin-left: 10px">
        <p style="color: dimgrey;float: left" >共{{total}}条</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {
  uploadFile2OSS
} from "@/utils/OSSUpload";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {isVaild} from "@/utils/validate";
import {Boot} from "@wangeditor/editor";
import {
  getAllCSDocumentList
} from "@/api/system/CSDocument/file";
import config from "@/utils/config";

export default Vue.extend({
  components: {Editor, Toolbar},
  data() {
    //上传照片
    const handleUploadPic = async (file, insertFn) => {
      // console.log(file)
      getOSSUploadInfo({DataType: "11", ID: 0}).then(async (res) => {  //超人圈图片上传
        this.ossInfo = res.resultData;
        this.ossPath = res.resultData.PicSavePath;
        let exname = file.name.substring(file.name.lastIndexOf(".") + 1);
        const fileTypes = ["jpg", "png", "jpeg",'gif'];
        var index = fileTypes.indexOf(exname)
        if (index < 0) {
          this.$message({
            message: "上传文件只能是 JPG / PNG / JPEG / GIF 格式",
            type: "warning",
          });
          return false;
        }
        this.fileFormat = fileTypes[index];
        await this.uploadFile(file).then(res => {
          if (res !== null && res !== [null, null] && res[0] !== null) {
            if(res[0].indexOf('/UploadFiles')!== -1){
              res[0]=config.RESOURCES+res[0].substring(res[0].indexOf('/UploadFiles'))
            }
            if (res[0].indexOf('?uploadId') !== -1) {
              res[0] = res[0].substring(0, res[0].indexOf('?uploadId'))
            }
            insertFn(res[0], "", "")
            this.fileInfoList.push({name:file.name,size:file.size,type:file.type,fileUrl:res[0]})
          }
        })
      });
    }
    //上传视频
    const handleUploadVideo = async (file, insertFn) => {
      // console.log(file)
      getOSSUploadInfo({DataType: "11", ID: 0}).then(async (res) => { //超人圈视频上传
        this.ossInfo = res.resultData;
        this.ossPath = res.resultData.PicSavePath;
        let exname = file.name.substring(file.name.lastIndexOf(".") + 1);
        const fileTypes = ["mp4"];
        var index = fileTypes.indexOf(exname)
        if (index < 0) {
          // editor.alert('错误信息', 'error')
          this.$message({
            message: "上传文件只能是 MP4 格式",
            type: "warning",
          });
          return false;
        }
        this.fileFormat = fileTypes[index];
        await this.uploadFile(file).then(res => {
          // console.log(res)
          if (res !== null && res !== [null, null] && res[0] !== null) {
            if(res[0].indexOf('/UploadFiles')!== -1){
              res[0]=config.RESOURCES+res[0].substring(res[0].indexOf('/UploadFiles'))
            }
            if (res[0].indexOf('?uploadId') !== -1) {
              res[0] = res[0].substring(0, res[0].indexOf('?uploadId'))
            }
            if(res[1].indexOf('/UploadFiles')!== -1){
              res[1]=config.RESOURCES+res[1].substring(res[1].indexOf('/UploadFiles'))
            }
            let poster = res[1] == null ? "" : res[1]
            // console.log(res)
            insertFn(res[0], poster)
            this.fileInfoList.push({name:file.name,size:file.size,type:file.type,fileUrl:res[0],cover:poster})
          }
        })
      });
    }
    //上传文件
    const handleUploadFile = async (file, insertFn) => {
      console.log(file)
      getOSSUploadInfo({DataType: "12", ID: 0}).then(async (res) => { //超人圈附件上传
        this.ossInfo = res.resultData;
        this.ossPath = res.resultData.PicSavePath;
        this.fileFormat = file.name.substring(file.name.lastIndexOf(".") + 1);
        await this.uploadFile(file).then(res => {
          // console.log(res)
          if (res !== null && res !== [null, null] && res[0] !== null) {
            if(res[0].indexOf('/UploadFiles')!== -1){
              res[0]=config.RESOURCES+res[0].substring(res[0].indexOf('/UploadFiles'))
            }
            if (res[0].indexOf('?uploadId') !== -1) {
              res[0] = res[0].substring(0, res[0].indexOf('?uploadId'))
            }
            console.log(res)
            insertFn(file.name, res[0])
            this.uploadAccessoryFileList.push({name:file.name,size:file.size,type:file.type,fileUrl:res[0]})
          }
        })
      });
    }
    return {
      fileInfoList:[], //上传图片、视频列表
      uploadAccessoryFileList: [],//上传附件列表
      quoteCsFileList: [],//引用附件列表（附件不一定在文件中）
      showDialog:false,
      editor: null,
      uploadVideoFileURL: null,
      uploadVideoFile: null,
      fileFormat: null,
      videoCover: null,//视频封面

      ossInfo: "",          // OSS信息
      ossPath: "",          // OSS路径
      html: '',

      showProgress: false,//进度条的显示
      progress: 0, //进度条数据

      //工具栏配置（插入一个文件上传按钮）
      toolbarConfig: {
        insertKeys: {
          index: 24, // 自定义插入的位置
          keys: ['uploadAttachment','editCode'], // “上传附件”菜单,选择客服文档列表菜单
        }
      },
      //编辑器配置（配置图片、视频、文件上传的响应函数）
      editorConfig: {
        placeholder: '在这里开始您的创作吧...',
        MENU_CONF: {
          maxNumberOfFiles: 1,
          allowedFileTypes: ["image/*"],
          uploadImage: {
            maxNumberOfFiles: 1,
            customUpload: handleUploadPic
          },
          uploadVideo: {
            customUpload: handleUploadVideo
          },
          uploadAttachment: {
            customUpload :handleUploadFile
          }
        },
        hoverbarKeys: {
          attachment: {
            menuKeys: ['downloadAttachment'], // “下载附件”菜单
          },
        }
      },//编辑器配置（默认即可）
      mode: 'default', // or 'simple'
      pageNumber: 1,
      pageSize: 10,
      csFileList: [],
      total: 0,
      filePlayName:"",      //文件完整名称
      //浏览文件配置参数
      showMp3:   false,
      showImg:   false,
      showDoc:   false,
      showPdf:   false,
      showVideo: false,
      fileUrl:    "",
      boxWidth: "",
      boxHeight:"",
    }
  },
  created(){
    let that = this
    if (this.config.OPEN_EDITOR === 0) {
      const menu1Conf = {
        key: 'editCode', // 定义 menu key ：要保证唯一、不重复（重要）
        factory() {
          return new MyButtonMenu(that)
        },
      }
      Boot.registerMenu(menu1Conf);
      this.config.OPEN_EDITOR = 1
    }
  },
  methods: {
    getCSDocumentList1(){
      this.csFileList = []
      return new Promise((resolve ,reject)=>{
        const param = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          type: 0
        };
        getAllCSDocumentList(param).then((res) =>{
          if(res.code === 200){
            this.csFileList=res.data.rows
            this.total=res.data.total
          }
        });
      });
    },
    currentChange(currentPage) {
      this.pageNumber = currentPage;
      this.getCSDocumentList1()
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    /**
     * 上传服务器
     *
     * @param {object} file 文件对象
     */
    async uploadFile(file) {
      const uploadFile = file; // 获取上传的file对象
      const uploadFileSize = uploadFile.size / 1024 / 1024; // 获取上传文件的大小，单位 MB

      //获取视频封面（若文件为视频）
      if (uploadFile.name.toLowerCase().endsWith(".mp4")) {
        this.uploadVideoFileURL = getLocalFileURL({raw: uploadFile})
        console.log(this.uploadVideoFileURL)
        await this.getVideoCover(this.uploadVideoFileURL)
      }

      //传封面（若有）
      var coverFileName = null;
      if (isVaild(this.videoCover)) {
        let timestamp = new Date().valueOf();
        let data = this.videoCover
        var str = data.split(",");
        var suffix = data.split(";")[0].split("/")[1];
        coverFileName = this.ossPath + "cover_from_video_" +
            timestamp + "." + suffix;
        var buffer = Buffer.from(str[1], 'base64');
        await uploadFile2OSS(this.ossInfo, buffer, coverFileName);
      }
      let filePath = await this.multipartUpload(file, uploadFileSize, isVaild(coverFileName) ? "/" + coverFileName : null)       //上传图片、视频、附件
      console.log(this.getImageUrl("/" + coverFileName))
      console.log(filePath)
      return [filePath, this.getImageUrl("/" + coverFileName)];
    },
    /**
     * 分片上传
     */
    async multipartUpload(file, uploadFileSize, videoCover) {
      let OSS = require("ali-oss");
      // 实例化OSS Client。
      let client = new OSS({
        region: this.config.OSS_END_POINT,
        accessKeyId: this.ossInfo.AssumeRoleToken.AccessKeyId,
        accessKeySecret: this.ossInfo.AssumeRoleToken.AccessKeySecret,
        stsToken: this.ossInfo.AssumeRoleToken.SecurityToken,
        bucket: this.config.OSSBUCKET,
        timeout: 600000,
      });

      const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p) => {
          //p进度条的值
          console.log(p)
          this.showProgress = true;
          this.progress = Math.floor(p * 100);
          if(p===1){
            setTimeout(() => {
              this.showProgress = false;
            }, 500)
          }
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 1024 * 1024,
      };
      let timestamp = new Date().valueOf();
      const fileName = file.lastModified + "_" + timestamp;
      var fileUrl = this.ossPath + fileName;
      if (this.fileFormat !== null) {
        fileUrl += "." + this.fileFormat
      }
      return client.multipartUpload(fileUrl, file, options).then((res) => {
        if (res.res.requestUrls.length > 0) {
          console.log(res.res.requestUrls)//新增记录
          return res.res.requestUrls[0];
          // this.addForumFile("/"+fileUrl,this.ForumID,this.fileType,uploadFileSize*1024,videoCover);
        } else {
          return ""
          this.$message.error("上传视频");
        }
      })
          .catch((err) => {
            return ""
            console.log("OSS文件上传失败:", err);
          });
    },
    getVideoCover(url) {
      return new Promise((resolve) => {
        const video = document.createElement("video") // 也可以自己创建video
        video.autoplay = true
        video.src = url; // url地址 url跟 视频流是一样的
        video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
        video.currentTime = 1; // 第一帧
        const canvas = document.createElement("canvas"); // 获取 canvas 对象
        const ctx = canvas.getContext("2d"); // 绘制2d
        video.oncanplay = async () => {
          // 利用canvas对象方法绘图
          await ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
          // 转换成base64形式(异步调用否则会得到空白的截取画面)
          this.videoCover = await this.drawVideoToCanvas(video)
          resolve();
          // video = null;
          console.log("getVideoCover " + this.videoCover)
        };
      });
    },
    drawVideoToCanvas(video) {
        return new Promise((resolve) => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL("image/png"))
        });
    },

    getImageUrl(row) {
      return getCloudUrl(row);
    },

    iconByType(row) {
      return row.fileSuffix.substring(row.fileSuffix.lastIndexOf(".") + 1, row.fileSuffix.length)
    },

    // 引用文件
    async quoteFile(row) {
      let quoteFileUrl = this.config.RESOURCES + row.downUrl
      let type = this.iconByType(row)
      let pushInfo = {name: row.fileShowName, size: row.fileSize, type: type, fileUrl: quoteFileUrl, csFileID:row.csFileID}
      if (type.indexOf("jpg") !== -1 || type.indexOf("png") !== -1 || type.indexOf("jpeg") !== -1) {
        this.editor.insertNode({type: 'image', src: quoteFileUrl, children: [{text: ''}]})
      }
      // 插入视频
      else if (type.indexOf("avi") !== -1 || type.indexOf("mp4") !== -1 || type.indexOf("webm") !== -1 || type.indexOf("m4v") !== -1 || type.indexOf("rmvb") !== -1 || type.indexOf("mpg") !== -1 || type.indexOf("3gp") !== -1 || type.indexOf("swf") !== -1 || type.indexOf("mkv") !== -1) {
        // 提取封面
        // await this.getVideoCover(quoteFileUrl)
        // var coverFileName = null;
        // if (isVaild(this.videoCover)) {
        //   let timestamp = new Date().valueOf();
        //   let data = this.videoCover
        //   var str = data.split(",");
        //   var suffix = data.split(";")[0].split("/")[1];
        //   coverFileName = this.ossPath + "cover_from_video_" +
        //       timestamp + "." + suffix;
        //   var buffer = Buffer.from(str[1], 'base64');
        //   await uploadFile2OSS(this.ossInfo, buffer, coverFileName);
        // }
        pushInfo.cover = ''
        // pushInfo.cover = this.videoCover
        // console.log(this.videoCover)
        this.editor.insertNode({type: 'video', src: quoteFileUrl, poster: '', children: [{text: ''}]})
      }
      // 插入附件
      else {
        this.editor.insertNode({
          type: 'attachment',
          fileName: row.fileShowName + '.' + type,
          link: quoteFileUrl,
          children: [{text: ''}]
        })
      }
      if (!this.quoteCsFileList.includes(pushInfo)) {
        this.quoteCsFileList.push(pushInfo)
      }
    },
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    //   let tempHtml='<p><span style="color: rgb(140, 140, 140); background-color: rgb(255, 255, 255); font-size: 15px;">南都报道</span><span style="color: rgb(140, 140, 140); background-color: rgb(255, 255, 255);"> </span><span style="color: rgb(64, 169, 255); background-color: rgb(255, 255, 255); font-size: 15px;">广州有咩事</span><span style="color: rgb(140, 140, 140); background-color: rgb(255, 255, 255);"> </span><span style="color: rgb(140, 140, 140); background-color: rgb(255, 255, 255); font-size: 15px;"><em>2023-09-21 00:00</em></span><span style="color: rgb(140, 140, 140); background-color: rgb(255, 255, 255);"> </span><span style="color: rgb(140, 140, 140); background-color: rgb(255, 255, 255); font-size: 15px;"><em>发表于广东</em></span></p><p style="text-align: center;"><img src="http://siuitestpub.oss-cn-qingdao.aliyuncs.com/UploadFiles/1083751/ForumVideos/1695264130434_1695264147127.gif" alt="" data-href="" style=""></p><p style="text-align: center;"><img src="http://siuitestpub.oss-cn-qingdao.aliyuncs.com/UploadFiles/1083751/ForumVideos/1695263301266_1695344196814.png" alt="" data-href="" style=""></p><p style="text-align: center;"><br></p><p style="text-align: left;"><span style="font-size: 15px;">9月19日，广州市住房和城乡建设局发布了《广州市人民政府办公厅关于进一步加强户籍家庭住房保障工作的通知（征求意见稿）》（下称《通知（征求意见稿）》），公开征求社会公众意见和建议。</span></p><p style="text-align: left;"><span style="font-size: 15px;"><strong>《通知（征求意见稿）》着重对户籍家庭住房保障政策进行“两调整两完善”：调整公租房保障家庭收入线准入限额，调整住房租赁补贴标准，完善公租房保障方式，完善公租房保障审核及监管机制。</strong></span></p><p style="text-align: left;"><strong>准入线从35660元/年变为49952元/年</strong></p><p style="text-align: left;"><span style="font-size: 15px;"><strong>《通知（征求意见稿）》拟将公租房收入线准入限额从现行的35660元/年提高到49952元/年，同时，对申请家庭所有成员均年满60周岁的家庭，放宽其家庭收入、家庭财产标准至政府公布标准的130%。</strong></span></p><p style="text-align: center;"><img src="http://siuitestpub.oss-cn-qingdao.aliyuncs.com/UploadFiles/1083751/ForumVideos/1695264131902_1695264226190.png" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-size: 15px;"><strong>住房租赁补贴方面，《通知（征求意见稿）》拟将标准从现行的30元/平方米/月提高到35元/平方米/月，对于按标准计算得出的每月住房租赁补贴不足200元的家庭，按照200元/月予以发放。</strong></span></p><p style="text-align: left;"><strong>超过5年仍未获配租可后申请租赁补贴</strong></p><p style="text-align: left;"><span style="font-size: 15px;"><strong>《通知（征求意见稿）》还规定，在现有低保家庭、最低生活保障边缘家庭等群体的基础上，拟增加三级及以上残疾人家庭，在轮候期间即可领取住房租赁补贴。同时，《通知（征求意见稿）》拟对于申请轮候公租房的家庭，曾参加配租意向登记未获配租且轮候时间超过5年仍未获配租的，可申请在后续轮候期间领取住房租赁补贴。</strong></span></p><p style="text-align: left;"><span style="font-size: 15px;">此外，《通知（征求意见稿）》拟对于全体保障对象均年满60周岁的在保家庭，期满审查时不再审核收入和财产，给予老年人住房困难群体稳定的居住保障。</span></p><p style="text-align: left;"><strong>如何提意见</strong></p><p style="text-align: left;"><span style="font-size: 15px;"><strong>征求意见时间：</strong></span></p><p style="text-align: left;"><span style="font-size: 15px;">2023年9月20日至2023年10月19日（共30日）。</span></p><p style="text-align: left;"><span style="font-size: 15px;"><strong>公众提交意见的途径：</strong></span></p><p style="text-align: left;"><span style="font-size: 15px;">1.可登录广州市住房和城乡建设局网站（http://zfcj.gz.gov.cn/）首页上的“互动交流”-“调查征集”栏目查看征求意见稿全文，并提交意见建议。2.可将相关意见和建议通过书面邮寄至广州市越秀区府前路1号广州市住房和城乡建设局住房改革和保障处，邮编510030；或发送电子邮件到邮箱gzcczbc@gz.gov.cn。</span></p><p style="text-align: left;"><span style="font-size: 15px;"><br></span></p><p style="text-align: left;"><span style="font-size: 15px;"><strong>广州有咩事（nandugz）、N视频报道南都记者 夏嘉雯 实习生 钟宇森 通讯员 穗建</strong></span></p><p style="text-align: center;"><br></p><div data-w-e-type="video" data-w-e-is-void>\n' +
    //       '<video poster="http://test.cloud.siui.com/UploadFiles/1083751/ForumVideos/cover_from_video_1695264266130.png" controls="true" width="auto" height="auto"><source src="http://siuitestpub.oss-cn-qingdao.aliyuncs.com/UploadFiles/1083751/ForumVideos/1695112775087_1695264266640.mp4" type="video/mp4"/></video>\n' +
    //       '</div><p style="text-align: left;"><br></p><p style="text-align: center;"><br></p>'
    //   this.html=tempHtml
    // }, 1500)
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  YourMenuClass(){
    console.log(1)
  }
})

class MyButtonMenu {
  constructor(vueInstance) {
    this.vueInstance = vueInstance;
    this.title = '未定义' // 自定义菜单标题
    this.iconSvg = '<svg t="1695875419267" class="icon" viewBox="0 0 1026 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6830" width="48" height="48"><path d="M1015.808 790.528q5.12 30.72-12.8 55.296t-48.64 29.696l-122.88 19.456q-29.696 5.12-54.784-12.8t-30.208-48.64l-104.448-661.504q-2.048-15.36 1.536-29.184t11.776-25.6 20.992-19.456 28.16-10.752l121.856-19.456q30.72-5.12 55.296 13.312t29.696 49.152zM500.736 63.488q30.72 0 52.224 21.504t21.504 52.224l0 684.032q0 30.72-21.504 52.224t-52.224 21.504l-106.496 0q-30.72 0-52.224-21.504t-21.504-52.224l0-684.032q0-30.72 16.384-52.224t48.128-21.504l115.712 0zM500.736 579.584q10.24 0 17.408-9.728t7.168-23.04q0-14.336-7.168-23.552t-17.408-9.216l-106.496 0q-10.24 0-17.408 9.216t-7.168 23.552q0 13.312 7.168 23.04t17.408 9.728l106.496 0zM500.736 449.536q10.24 0 17.408-9.728t7.168-24.064-7.168-23.552-17.408-9.216l-106.496 0q-10.24 0-17.408 9.216t-7.168 23.552 7.168 24.064 17.408 9.728l106.496 0zM179.2 63.488q30.72 0 52.736 21.504t22.016 52.224l0 684.032q0 30.72-22.016 52.224t-52.736 21.504l-106.496 0q-30.72 0-52.736-21.504t-22.016-52.224l0-684.032q0-30.72 22.016-52.224t52.736-21.504l106.496 0zM76.8 319.488q-11.264 0-18.432 9.216t-7.168 23.552q0 13.312 7.168 23.04t18.432 9.728l98.304 0q11.264 0 17.92-9.728t6.656-23.04q0-14.336-6.656-23.552t-17.92-9.216l-98.304 0zM179.2 641.024q11.264 0 17.92-9.216t6.656-22.528q0-14.336-6.656-23.04t-17.92-8.704l-102.4 0q-11.264 0-18.432 8.704t-7.168 23.04q0 13.312 7.168 22.528t18.432 9.216l102.4 0zM179.2 515.072q11.264 0 17.92-9.216t6.656-23.552-6.656-23.552-17.92-9.216l-102.4 0q-11.264 0-18.432 9.216t-7.168 23.552 7.168 23.552 18.432 9.216l102.4 0z" p-id="6831" fill="#515151"></path></svg>' // 可选 菜单图标
    this.tag = 'button'
  }

  // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
  getValue(editor) {                              // JS 语法
  }

  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive(editor) {                    // JS 语法
    return false
  }

  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled(editor) {                     // JS 语法
    return false
  }

  // 点击菜单时触发的函数
  exec(editor, value) {                           // JS 语法
    if (this.isDisabled(editor)) return
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>